/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Notfound_TitleInputs */

const en_directory_notfound_title = /** @type {(inputs: Directory_Notfound_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool not found`)
};

const zh_directory_notfound_title = /** @type {(inputs: Directory_Notfound_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工具未找到`)
};

/**
* | output |
* | --- |
* | "Tool not found" |
*
* @param {Directory_Notfound_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_notfound_title = /** @type {((inputs?: Directory_Notfound_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Notfound_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_notfound_title(inputs)
	return zh_directory_notfound_title(inputs)
});
export { directory_notfound_title as "directory.notfound.title" }